import { render } from "./NameView.vue?vue&type=template&id=310b37db&ts=true"
import script from "./NameView.vue?vue&type=script&lang=ts"
export * from "./NameView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__